var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['flippable-card', {
      flipping: _vm.isFlipped
    }],
    on: {
      "click": _vm.onCardClick
    }
  }, [_c('div', {
    staticClass: "card-front"
  }, [_vm._t("card-front")], 2), _c('div', {
    staticClass: "card-back"
  }, [_vm._t("card-back")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }